import { render, staticRenderFns } from "./AddTruckOrder.vue?vue&type=template&id=2ec3e56c&scoped=true&"
import script from "./AddTruckOrder.vue?vue&type=script&lang=js&"
export * from "./AddTruckOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddTruckOrder.vue?vue&type=style&index=0&id=2ec3e56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3e56c",
  null
  
)

export default component.exports